import { StatusBadge } from '@/components/base/StatusBadge';
import { getFarmerKyc } from '@/store';
import type { AdvanceRequest, Farmer, RiskLevel } from '@/types';
import { formatCurrencyCompact, formatDate } from '@/utils/format';

interface LoanCardProps {
  loan: AdvanceRequest;
  farmer: Farmer;
  farmerName: string;
  seasonName: string;
  riskMucDo?: RiskLevel;
  creditScore?: number;
  hanMucConLai: number;
  onViewDetail: () => void;
}

export default function LoanCard({ loan, farmer, farmerName, seasonName, riskMucDo, creditScore, hanMucConLai, onViewDetail }: LoanCardProps) {
  const kyc = getFarmerKyc(farmer);
  const ratio = hanMucConLai > 0 ? Math.min(100, loan.soTien / hanMucConLai * 100) : 100;
  return (
    <button type="button" onClick={onViewDetail} className="mobile-card min-w-0 p-3.5 text-left transition active:scale-[0.99]">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0"><h3 className="truncate text-sm font-bold text-slate-900">{farmerName}</h3><p className="metric-caption mt-0.5 truncate text-[10px] text-slate-400">{loan.id.toUpperCase()} · {formatDate(loan.ngayYeuCau)}</p></div>
        <StatusBadge status={loan.status} />
      </div>
      <p className="mt-3 text-lg font-bold text-agrida-700">{formatCurrencyCompact(loan.soTien)}</p>
      <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-slate-500">{loan.mucDich}</p>

      <div className="mt-3 grid grid-cols-2 gap-2">
        <div className="rounded-xl bg-slate-50 p-2.5"><p className="text-[10px] text-slate-400">Hạn mức còn</p><p className="mt-0.5 truncate text-xs font-bold text-slate-800">{formatCurrencyCompact(hanMucConLai)}</p></div>
        <div className="rounded-xl bg-slate-50 p-2.5"><p className="text-[10px] text-slate-400">Hồ sơ</p><p className="mt-0.5 truncate text-xs font-bold text-slate-800">{kyc.kycStatus === 'ekyc_verified' ? 'eKYC hợp lệ' : 'Cần bổ sung'}</p></div>
      </div>
      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-100"><div className={`h-full rounded-full ${ratio > 100 ? 'bg-rose-500' : 'bg-agrida-500'}`} style={{ width: `${Math.min(100, ratio)}%` }} /></div>
      <div className="mt-2 flex min-w-0 items-center justify-between gap-2 text-[10px] text-slate-400"><span className="truncate">{seasonName || 'Không gắn mùa vụ'}</span><span className="shrink-0">Score {creditScore || '--'} · {riskMucDo || 'Chưa đánh giá'}</span></div>
    </button>
  );
}
